// Mock data for GWM website

// GWM team photos — 6 images of in-house team in modern office (used randomly across pages)
export const teamPhotos = [
  'https://images.unsplash.com/photo-1758873268663-5a362616b5a7?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80',
  'https://images.unsplash.com/photo-1758518729685-f88df7890776?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80',
  'https://images.unsplash.com/photo-1768659347532-74d3b1efb0ae?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80',
  'https://images.unsplash.com/photo-1758873268851-feebbfb1d037?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80',
  '/assets/images/stock/pexels-23496667.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400',
  '/assets/images/stock/pexels-8117466.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400',
];

// Deterministic picker — given a seed (e.g., page name) returns a team photo
export const getTeamPhoto = (seed = '') => {
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash * 31 + seed.charCodeAt(i)) & 0xffffffff;
  }
  return teamPhotos[Math.abs(hash) % teamPhotos.length];
};



export const navigationLinks = [
  { name: 'Home', path: '/' },
  { name: 'Blog', path: '/blog' },
  { name: 'About', path: '/about-us' },
  { name: 'Contact Us', path: '/contact' },
  { name: 'FAQs', path: '/faqs' },
  { name: 'HTML Sitemap', path: '/sitemap' }
];

export const services = [
  { name: 'SEO Services', path: '/seo-services' },
  { name: 'Local SEO', path: '/local-seo' },
  { name: 'PPC / AdWords Management', path: '/pay-per-click-ppc-adwords-management' },
  { name: 'HTTPS Migration', path: '/https-migration' },
  { name: 'Google Penalty Removal', path: '/google-penalty-removal' },
  { name: 'Online Reputation Management', path: '/online-reputation-management' },
  { name: 'Link Building Services', path: '/link-building-services' },
  { name: 'SEO for Automotive', path: '/seo-for-automotive' },
  { name: 'SEO for Construction', path: '/seo-for/construction' },
  { name: 'SEO for Fashion', path: '/seo-for-fashion' },
  { name: 'SEO for Franchises', path: '/seo-for-franchises' },
  { name: 'SEO for Healthcare', path: '/seo-for-healthcare' },
  { name: 'SEO for Lawyers', path: '/seo-for-lawyers' },
  { name: 'SEO for Retail', path: '/seo-for-retail' },
  { name: 'SEO for Small Business', path: '/seo-for-small-business' }
];

export const blogPosts = [
  {
    id: 1,
    title: 'Why are Professional SEO services important?',
    excerpt: 'Why are Professional SEO services important? Although creating high-quality SEO isn\'t brain surgery,',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=333&fit=crop',
    date: 'Feb 18, 2021'
  },
  {
    id: 2,
    title: 'What is the difference between onPage and offPage SEO?',
    excerpt: 'What is the difference between onPage and offPage SEO? And, more importantly, why',
    image: 'https://images.unsplash.com/photo-1557838923-2985c318be48?w=400&h=420&fit=crop',
    date: 'Feb 18, 2021'
  },
  {
    id: 3,
    title: 'What is SEO',
    excerpt: 'What is SEO Search Engine Optimisation (SEO) refers to the activities conducted',
    image: 'https://images.unsplash.com/photo-1571721795195-a2ca2d3370a9?w=800&h=333&fit=crop',
    date: 'Feb 18, 2021'
  },
  {
    id: 4,
    title: 'The Importance of keywords in SEO Searches',
    excerpt: 'The Importance of Keywords in SEO searches For years, search engines used keywords',
    image: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=800&h=333&fit=crop',
    date: 'Feb 18, 2021'
  },
  {
    id: 5,
    title: 'The decline of Black Hat SEO tactics',
    excerpt: 'The decline of Black Hat SEO Goodbye and Good Riddance First, by definition,',
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=333&fit=crop',
    date: 'Feb 18, 2021'
  },
  {
    id: 6,
    title: 'SEO brands',
    excerpt: 'SEO brands During 2016, Google\'s algorithm has been continuously updated. The changes that',
    image: 'https://images.unsplash.com/photo-1432888498266-38ffec3eaf0a?w=800&h=333&fit=crop',
    date: 'Feb 18, 2021'
  }
];

export const seoMethodFeatures = [
  {
    icon: 'Search',
    title: 'Website Analysis',
    description: 'We begin with a comprehensive evaluation of where your website is now. This allows us to review existing content, pinpoint areas of improvement and construct a plan to move forward.'
  },
  {
    icon: 'Users',
    title: 'Competitor Analysis',
    description: 'It is always important to understand what you\'re up against. Our aim is to gain an understanding of your competitors and create a way for you to stand out.'
  },
  {
    icon: 'Key',
    title: 'Select Keywords',
    description: 'We use the latest keyword research technology to determine the phrases that are most relevant to your business. Keywords are chosen with a focus on ROI, rather than simply traffic.'
  },
  {
    icon: 'PenTool',
    title: 'Content Creation',
    description: 'Once we\'ve conducted a competitor and market-place review and analysis of keywords, our specialist writers will start to create content. This will help improve your visibility for search engines and improve your rankings in Google.'
  },
  {
    icon: 'Link',
    title: 'In-bound Links',
    description: 'Our SEO engineers will then analyse your website\'s current link profile and remove all undesirable links, which may be doing more harm than good. All of our link building activities are based on white-hat strategies to enhance your SERP rankings.'
  },
  {
    icon: 'Settings',
    title: 'On-Page Optimisation',
    description: 'Whilst link-building is a long-term essential SEO strategy, it is also essential to get your on-page optimisation right. Our team of SEO experts do this by enhancing the structure, design, speed, indexing and meta tags and descriptions on your website.'
  },
  {
    icon: 'FileText',
    title: 'Quality Content',
    description: 'You can only imagine the volume of content on the internet, covering every topic imaginable, thousands of times over. This is why it\'s so important to ensure all of your content is of a high quality and relevant to ensure your SEO success.'
  },
  {
    icon: 'TrendingUp',
    title: 'Ongoing Search Engine Optimisation',
    description: 'As part of our quality control process we will provide you with a monthly report that tracks the ongoing improvement in each of your keyword rankings and outlines the work that we have completed that month.'
  },
  {
    icon: 'BarChart',
    title: 'Reporting & Tracking',
    description: 'In addition to providing the monthly performance reports, we will schedule a monthly screen share meeting to review the results with you and identify any issues that need to be addressed.'
  }
];

export const whyBusinessesChooseGWM = [
  {
    icon: 'Lock',
    title: 'No Lock-In Contracts',
    description: 'We don\'t require long-term commitments because we are confident in our service and in your success.'
  },
  {
    icon: 'TrendingUp',
    title: 'Results Guaranteed',
    description: 'If we do not meet any of our keyword guarantees we will work for free until we do!'
  },
  {
    icon: 'MessageCircle',
    title: 'No Minimum Notice Period',
    description: 'You can pause your campaign with us at any time, just send us an email.'
  },
  {
    icon: 'CreditCard',
    title: 'No Exit/Cancellation Fees',
    description: 'We provide regular reporting sessions with your technical SEO lead and your account manager to guarantee your success.'
  },
  {
    icon: 'Search',
    title: '100% Transparency',
    description: 'Everything we do will be shared directly with you; we refuse to hide anything!'
  },
  {
    icon: 'Monitor',
    title: 'Interactive Real-Time Reporting',
    description: 'All of our clients receive a custom dashboard to track their account in real-time.'
  }
];

export const testimonials = [
  {
    title: 'GWM IS MAGIC',
    subtitle: 'BUT DON\'T JUST TAKE OUR WORD FOR IT',
    author: 'Ben Kierath',
    text: 'Ben Kierath chose Green Web marketing for two of his businesses, Hoselink and True Pro-tein. In the video, Ben explains the service he received as well as some extraordinary results.',
    websites: ['hoselink.com.au', 'trueprotein.com.au'],
    videoThumb: 'https://images.unsplash.com/photo-1553877522-43269d4ea984?w=600&h=400&fit=crop'
  },
  {
    title: 'GWM IS PROFICIENT',
    text: 'The talented people at GWM Ranked our website on Page 1 of Google for our main keywords such as \'Corporate Training\' in only two months.',
    websites: ['breakthroughcorporatetraining.com.au'],
    videoThumb: 'https://images.unsplash.com/photo-1552581234-26160f608093?w=600&h=400&fit=crop'
  },
  {
    title: 'GWM IS HONEST',
    author: 'Ziad',
    text: 'Within short period of time, we have 18 keywords on page #1 of Google which is an outstanding results and good return on investment.',
    websites: ['totalappliancerepaircentre.com.au'],
    videoThumb: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=600&h=400&fit=crop'
  }
];

export const contactInfo = {
  address: '5 Martin Pl',
  city: 'Sydney NSW 2000',
  country: 'Australia',
  phone: '1800 006 296'
};

export const locations = [
  {
    city: 'SYDNEY',
    address: '5 Martin Pl',
    suburb: 'Sydney NSW 2000',
    phone: '1800 006 296'
  },
  {
    city: 'MELBOURNE',
    address: '1/1 Macquarie St',
    suburb: 'Prahran, VIC 3181',
    phone: '1800 006 296'
  },
  {
    city: 'BRISBANE',
    address: '2/2 Pittwin Rd N',
    suburb: 'Capalaba QLD 4157',
    phone: '1800 006 296'
  }
];

export const founderStory = `I have a confession to make, I'm a Google Geek! There you go, I said it.

After completing my Masters in Engineering, I followed the normal and predictable path in a safe, well paid job in corporate Australia. A few years on, going through the motions of my mundane 9 to 5 job, like most entrepreneurs, I had an epiphany. This was not the path for me.

So, I started working on my grand plan to market widgets to the world via the world wide web. Working through the night on my new e-commerce venture, I finally launched my grand new business to a world that had been waiting with bated breath for my exciting new offer. Launch day finally came, and I excitedly clicked on my customer enquiries page, and low and behold, not a single enquiry. A week or so on, and with some tweaks to my home page and checkout, I re-launched. Miraculously, not a sale, Zero, Nada, Zilch! And so, began my real-life journey into the world of search-engine-optimization and pay-per-click. I spent hours, days, weeks, months consuming every SEO article, online course, blog and book ever written about driving traffic to a website.

It became all-consuming as I lapped up every piece of knowledge, becoming obsessed about how Google algorithms worked and how best to navigate the complex world of SEO.

This journey led me to a job at a leading digital marketing agency in Sydney. Whilst at first over the moon at landing my dream job, I gradually become frustrated and disenchanted at the service levels and value that my employer was providing to its clients. I realised that I could provide a far better service for a fraction of the price, and with little more than a laptop and big dream this was the birth of my own SEO Agency, Green Web Marketing.

Finally, being able to put into practice all that I had learnt, our own site had outranked all our competitors within six months, in the most fiercely competitive SEO market, Sydney. And the rest they say is history……

Oh, and I almost forgot to mention the only thing I love more than search engine optimisation, is my beautiful French Poodle, Lucy.`;

export const faqs = [
  {
    question: 'What is SEO?',
    answer: 'Search Engine Optimisation (SEO) refers to the activities conducted to improve your website\'s visibility in search engine results pages (SERPs). It involves optimizing your website\'s content, structure, and technical aspects to rank higher for relevant search queries.'
  },
  {
    question: 'How long does SEO take to show results?',
    answer: 'SEO typically takes 3-6 months to show significant results. However, we guarantee results within 120 days or we work for free until we achieve your keyword rankings.'
  },
  {
    question: 'What is the difference between SEO and Google Ads?',
    answer: 'SEO focuses on organic rankings through content optimization and link building, while Google Ads provides immediate visibility through paid advertisements. SEO is a long-term investment, while Google Ads delivers instant traffic.'
  },
  {
    question: 'Do you offer a guarantee?',
    answer: 'Yes! If we do not meet any of our keyword guarantees, we will work for free until we do. We also have no lock-in contracts and no exit fees.'
  },
  {
    question: 'What makes GWM different from other SEO agencies?',
    answer: 'We offer transparent reporting, guaranteed results, no lock-in contracts, and no hidden fees. Our team has proven success in ranking websites in competitive markets like Sydney.'
  }
];